var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"property-container"},[_c('h3',[_vm._v("Properties")]),_c('PropertyBuySellControls'),_c('div',{staticClass:"properties-container"},[_c('PropertyCard')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }